import React, { useState, useEffect } from 'react';
import api from "../../services/api";
import { Modal, Col, Row, Form } from 'react-bootstrap';
import IcX from '../../components/Svg/IcX';
import styleButton from '../Button/Button.module.css'
import styles from './style.module.css'
import Permissions from '../Permissions';
import Loading from '../Loading';
import useWrapper from "../../hooks/useWrapper";
import { toast } from 'react-toastify';

const ModalPermissionModel = props => {
  const { show, onHide, reload, setreload, isBatch } = props;

  const { config } = useWrapper();
  const [loaded, setloaded] = useState(false);

  const defaults = {
    model: {
      name: "",
      description: ""
    },
    permissions: {
      trainee: {
        create: false,
        reading: false,
        update: false,
        financialReading: false,
        updatePassword: false
      },
      calendar: {
        createForClass: false,
        editForClass: false,
        create: false,
        update: false,
        recalc: false
      },
      commercial: {
        create: false,
        reading: false,
        update: false,
        readingFunnel: false,
        createModel: false,
        updateModel: false,
        createLegacy: false
      },
      attendance: {
        create: false,
        reading: false,
        sendMessages: false,
        updateInfos: false,
        finishAttendance: false
      },
      financialGroup: {
        reading: false,
        create: false,
        update: false,
        paymentDown: false
      },
      financialCompany: {
        reading: false,
        create: false,
        update: false
      },
      suppliers: {
        create: false,
        reading: false,
        update: false
      },
      institutions: {
        create: false,
        reading: false,
        update: false
      },
      reports: {
        reading: false
      }
    }
  }
  const [model, setmodel] = useState(defaults.model);
  const [permissions, setpermissions] = useState(defaults.permissions);

  const closeModal = () => {
    onHide();
    setmodel(defaults.model);
    setpermissions(defaults.permissions);
  }

  const createModel = async () => {
    const { name, description } = model;
    await api.post('/template-permission', {
      name,
      description,
      permissions
    }, config);
    setreload(!reload);
    onHide();
    toast.success("Modelo criado com sucesso!");
  }
  const editModel = async () => {
    const { name, description } = model;
    await api.put(`/template-permission/${show}`, {
      name,
      description,
      permissions
    }, config);
    setreload(!reload);
    onHide();
    toast.success("Modelo editado com sucesso!");
  }

  useEffect(() => {
    setloaded(false);
    if (show && show !== "new") {
      (async function () {
        const _template = await api.get(`/template-permission/${show}`, config);
        setmodel({
          name: _template.data.name,
          description: _template.data.description
        });
        setpermissions(JSON.parse(_template.data.permissions));
        setloaded(true);
      })()
    }
    else {
      setloaded(true);
    }
  }, [show]);

  return (
    <Modal show={show} onHide={closeModal} size="xl">
      <Modal.Header className="border">
        <Modal.Title>{show !== "new" ? "Editar" : "Novo"} Modelo</Modal.Title>
        <button className={styles.closeModal} onClick={() => { closeModal(); }}>
          <IcX />
        </button>
      </Modal.Header>
      {loaded ? (
        <Modal.Body className="bgWhite">
          <Row>
            <Col>
              <Form.Group>
                <span>Nome do Modelo</span>
                <input
                  type="text"
                  value={model.name}
                  placeholder="Insira o nome do Modelo..."
                  onChange={ev => {
                    setmodel({
                      ...model,
                      name: ev.target.value
                    })
                  }}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className='mt-2'>
            <Col>
              <Form.Group>
                <span>Descrição</span>
                <input
                  type="text"
                  value={model.description}
                  placeholder="..."
                  onChange={ev => {
                    setmodel({
                      ...model,
                      description: ev.target.value
                    })
                  }}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className='mt-2'>
            <Col>
              <Form.Group>
                <span>Permissões</span>
                <Permissions
                  setpermissions={(group, action, value) => {
                    let _value = !!permissions ? permissions[group][action] : false;
                    setpermissions({
                      ...permissions,
                      [group]: {
                        ...permissions[group],
                        [action]: value !== undefined ? value : !_value
                      }
                    })
                  }}
                  setAll={(group, value) => {
                    const _group = permissions[group];

                    Object.keys(_group).forEach(function (__action) {
                      _group[__action] = value;
                    });
                    setpermissions({
                      ...permissions,
                      [group]: _group
                    })
                  }}
                  permissions={[
                    {
                      label: "Formando",
                      group: "trainee",
                      options: [
                        { label: "Criação", value: permissions?.trainee?.create, action: "create" },
                        { label: "Leitura", value: permissions?.trainee?.reading, action: "reading" },
                        { label: "Edição", value: permissions?.trainee?.update, action: "update" },
                        { label: "Leitura do Financeiro", value: permissions?.trainee?.financialReading, action: "financialReading" },
                        { label: "Alterar senha", value: permissions?.trainee?.updatePassword, action: "updatePassword" },
                      ]
                    },
                    {
                      label: "Calendário",
                      group: "calendar",
                      options: [
                        { label: "Criar para turma", value: permissions?.calendar?.createForClass, action: "createForClass" },
                        { label: "Editar para turma", value: permissions?.calendar?.editForClass, action: "editForClass" },
                        { label: "Criar para usuário", value: permissions?.calendar?.create, action: "create" },
                        { label: "Editar para usuário", value: permissions?.calendar?.update, action: "update" },
                        { label: "Recalcular Calendario", value: permissions?.calendar?.recalc, action: "recalc" },
                      ]
                    },
                    {
                      label: "Comercial",
                      group: "commercial",
                      options: [
                        { label: "Criação", value: permissions?.commercial?.create, action: "create" },
                        { label: "Leitura", value: permissions?.commercial?.reading, action: "reading" },
                        { label: "Edição", value: permissions?.commercial?.update, action: "update" },
                        { label: "Leitura Filtro", value: permissions?.commercial?.readingFunnel, action: "readingFunnel" },
                        { label: "Criar Modelos", value: permissions?.commercial?.createModel, action: "createModel" },
                        { label: "Atualizar Modelos", value: permissions?.commercial?.updateModel, action: "updateModel" },
                        { label: "Criação de Turma Legado", value: permissions?.commercial?.createLegacy, action: "createLegacy" },
                      ]
                    },
                    {
                      label: "Atendimento",
                      group: "attendance",
                      options: [
                        { label: "Criação", value: permissions?.attendance?.create, action: "create" },
                        { label: "Leitura", value: permissions?.attendance?.reading, action: "reading" },
                        { label: "Enviar Mensagem", value: permissions?.attendance?.sendMessages, action: "sendMessages" },
                        { label: "Atualizar Informações", value: permissions?.attendance?.updateInfos, action: "updateInfos" },
                        { label: "Finalizar Atendimento", value: permissions?.attendance?.finishAttendance, action: "finishAttendance" },
                      ]
                    },
                    {
                      label: "Financeiro da Turma",
                      group: "financialGroup",
                      options: [
                        { label: "Criação", value: permissions?.financialGroup?.create, action: "create" },
                        { label: "Leitura", value: permissions?.financialGroup?.reading, action: "reading" },
                        { label: "Edição", value: permissions?.financialGroup?.update, action: "update" },
                        { label: "Pagamento Manual", value: permissions?.financialGroup?.paymentDown, action: "paymentDown" },
                      ]
                    },
                    {
                      label: "Financeiro da Empresa",
                      group: "financialCompany",
                      options: [
                        { label: "Criação", value: permissions?.financialCompany?.create, action: "create" },
                        { label: "Leitura", value: permissions?.financialCompany?.reading, action: "reading" },
                        { label: "Edição", value: permissions?.financialCompany?.update, action: "update" },
                      ]
                    },
                    {
                      label: "Fornecedores",
                      group: "suppliers",
                      options: [
                        { label: "Criação", value: permissions?.suppliers?.create, action: "create" },
                        { label: "Leitura", value: permissions?.suppliers?.reading, action: "reading" },
                        { label: "Edição", value: permissions?.suppliers?.update, action: "update" },
                      ]
                    },
                    {
                      label: "Instituições",
                      group: "institutions",
                      options: [
                        { label: "Criação", value: permissions?.institutions?.create, action: "create" },
                        { label: "Leitura", value: permissions?.institutions?.reading, action: "reading" },
                        { label: "Edição", value: permissions?.institutions?.update, action: "update" },
                      ]
                    },
                    {
                      label: "Relatórios",
                      group: "reports",
                      options: [
                        { label: "Leitura", value: permissions?.reports?.reading, action: "reading" }
                      ]
                    },

                  ]}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
      ) : (
        <Modal.Body>
          <Loading />
        </Modal.Body>
      )}
      <Modal.Footer>
        <div className="d-flex justify-content-end">
          {show !== "new" ? (
            <button
              className={styleButton.button_primary}
              onClick={() => {
                editModel();
              }}
            >
              Editar Modelo
            </button>
          ) : (
            <button
              className={styleButton.button_primary}
              onClick={() => {
                createModel();
              }}
            >
              Criar Modelo de Permissão
            </button>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalPermissionModel 